module.exports = __webpack_public_path__ + "img/costarica.d2091786.svg";